import { LibraryTitle } from '@treams/treams-ui';
import * as graphql from 'generated/graphql';

export default function EngagementCategoryTitle(props: {
	category: graphql.EngagementCategory;
	onChange: (title: graphql.LocalizedString) => Promise<void>;
}) {
	const [archive] = graphql.useArchiveEngagementCategoryMutation();
	const [restore] = graphql.useRestoreEngagementCategoryMutation();

	return (
		<LibraryTitle
			isArchived={props.category.isArchived}
			title={props.category.title}
			onArchive={async () => {
				await archive({ variables: { input: { id: props.category.id } } });
			}}
			onRestore={async () => {
				await restore({ variables: { input: { id: props.category.id } } });
			}}
			onChange={props.onChange}
		/>
	);
}
